export const QA_NAME_PHASE_BAR_CHEVRON = 'rentalPortalPhaseChevron'

export const QA_NAME_PHASE_STRIP = 'rentalPortalPhaseStrip'

export const QA_NAME_PHASE_STRIP_ACTION = 'rentalPortalPhaseStripAction'

export const QA_NAME_PHASE_STRIP_RETRY = 'rentalPortalPhaseStripRetry'

export const PHASE_STRIP_SEARCH_PARAM = 'phase'

export const PHASE_BAR_KEY_ATTRIBUTE = 'data-phase-key'

export const PHASE_STRIP_ITEM_STATE = {
  done: 'done',
  needsYou: 'needs_you',
  open: 'open',
}

export const PHASE_STRIP_TITLE_KEY = {
  active: 'RentalPortal.PhaseStripActiveTitleKey',
  done: 'RentalPortal.PhaseStripDoneTitleKey',
  upcoming: 'RentalPortal.PhaseStripUpcomingTitleKey',
}

export const PHASE_STRIP_AWAITING_APPROVAL_TEXT_COLOR = 'var(--color-warning)'

export const PHASE_STRIP_SKELETON_ROW_COUNT = 3

export const PHASE_STATE = {
  active: 'active',
  done: 'done',
  upcoming: 'upcoming',
}
